export const DEVICE = 'SMD';
export const TYPE = 'SMT';
export const LOG = 'SML';
